import React from "react";

import * as rcl from "./_csRcl";

import * as cv from "./_cv";
import * as cr from "./_cr";
import * as cs from "./_ca";
import * as ht from "./_ht";

import { useCmnz } from "./_csCmn";
import { a } from "./_csAbt";

import * as AmdC from "./_ccbAmdC";
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as BtnC from "./_cccBtnC";
import * as TextC from "./_ccbTextC";

const _mdlz = rcl.grtAtom("mdlz", {
  bShow: false,
  bCls: true,
  oClds: [],
  onCls: undefined,
});

export const useMdlz = () => {
  const _dz = rcl.grtStt(_mdlz);
  return _dz;
};

const _MdlIpt = React.memo((pDz: ht.dz) => {
  const _sMdlz = useMdlz();
  const _abtType = 'nmlz';
  const _abtz = cs.mdlIptAbtz[_abtType]();
  return (
    cr.c(BoxC.N, {
      key: -10,
      boxStlz: _abtz.boxStlz,
      oClds:
        _sMdlz.crt.ls.map((_dz: ht.dz, _idx: ht.n) => (
          cr.c(BtnC.N, {
            key: _idx,
            pslPtyz: {
              onPress: () => {
                if (_sMdlz.crt.onPrs) _sMdlz.crt.onPrs(_dz);
                _sMdlz.set({
                  bShow: false,
                });
              },
            },
            lblCz: {
              textz: {
                pfx: _dz.pfx,
                ept: _dz.ept,
              },
            },
          })
        ))
    })
  )
});

const _Mdl = React.memo(() => {

  const _sMdlz = useMdlz();

  const _abtType = 'nmlz';
  const _abtz = cs.mdlAbtz[_abtType]();

  if (_sMdlz.crt.bShow == false) return null;

  let _o = null;

  _o = _sMdlz.crt.oClds;

/*
  if (_sMdlz.crt.mdlType == "dwr") {
    _o = cr.c(BoxC.N, {
      key: -10,
      boxStlz: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: 100,
        height: 100,
        backgroundColor: 'red',
      }
    })
  }

  if (_sMdlz.crt.mdlType == "ipt") {
    _o = cr.c(_MdlIpt, {
      key: -10,
      textCz: {
        textz: {
          pfx: "■□■□■□■□■ ■□■□■□■□■ ■□■□■□■□■ ■□■□■□■□■ ■□■□■□■□■ ■□■□■□■□■ ■□■□■□■□■ ■□■□■□■□■ ■□■□■□■□■ ■□■□■□■□■ ",
        },
      },
    });
  }
*/

  const _clsMdl = () => {
    _sMdlz.set({
      bShow: false,
    });
    if (_sMdlz.crt.onCls) _sMdlz.crt.onCls();
  };

  return cr.c(BoxC.N, {
    key: "Mdl.root",
    boxStlz: {
      ... _abtz.boxStlz,
    },
    oClds: [

      cr.c(BoxC.N, { // mask
        key: -10,
        boxStlz: {
          ... _abtz.maskz.boxStlz,
        },
        pslPtyz: {
          onPress: _clsMdl,
        },
      }),

      cr.c(BoxC.N, { // main
        key: -20,
        boxStlz: {
          ... _abtz.mainz.boxStlz,
          ... _sMdlz.crt.boxStlz,
        },
        oClds: [
          _sMdlz.crt.bCls ?
          cr.c(BtnC.N, {
            key: -10,
            boxStlz: {
              ... _abtz.btnz.boxStlz,
            },
            lblCz: {
              textz: {
                pfx: `閉じる`,
                ... _abtz.btnz.textz,
              }
            },
            pslPtyz: {
              onPress: _clsMdl
            }
          })
          : undefined,
          _o,
        ],
      }),

    ],
  });
});
export const N = _Mdl;
